var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { colors, fontWeights } from "syf-component-library/defaultTheme";
import { Link } from "syf-component-library/ui";
export var TelephoneLink = styled(Link)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-decoration: underline;\n  color: ", ";\n  margin: 0;\n  font-weight: ", ";\n  display: inline;\n  padding: 0px;\n"], ["\n  text-decoration: underline;\n  color: ", ";\n  margin: 0;\n  font-weight: ", ";\n  display: inline;\n  padding: 0px;\n"])), colors.cyanBlue, fontWeights.regular);
var templateObject_1;
//# sourceMappingURL=TelephoneLink.js.map